import AddressVerificationProvider from '../addressVerification/AddressVerificationProvider';
import AddressForm from '../addressVerification/AddressForm';
import StateFilter from '../tnew/lib/StateFilter';
import dom from '../utils/dom';

const { FieldValidationProvider } = window.tnew.lib;
const { formButtonHandler } = window.tnew.handlers;

/** @typedef {import('../addressVerification/types').Address} Address */


class AccountCreateUpdateFormHandler {
  /**
   * @param {HTMLFormElement} $form
   * @param {boolean} isAddressVerificationEnabled
   * @param {Object} stateFilterConfig
   * @param {Address} primaryAddress
   * @param {boolean} isRecaptchaEnabled
   */
  constructor($form, isAddressVerificationEnabled, stateFilterConfig, primaryAddress = null, isRecaptchaEnabled = false) {
    this.$form = $form;
    this.isRecaptchaEnabled = isRecaptchaEnabled;

    FieldValidationProvider.createStandardProvider(this.$form.id);

    new StateFilter(stateFilterConfig);

    this.addressForm = new AddressForm(this.$form);

    this.avsProvider = new AddressVerificationProvider(this.addressForm, primaryAddress, isAddressVerificationEnabled);

    this.$form.addEventListener('submit', this.onSubmit);
  }

  onSubmit = async (event) => {
    const { $form, avsProvider, addressForm } = this;

    if (this.testShouldVerifyAddress()) {
      event.preventDefault();

      const response = await avsProvider.verifyAddress();

      if (response) {
        if (response.wasCancelled) {
          response.modal.close();

          formButtonHandler.resetButtonStyling();

          return;
        }

        addressForm.updateAddress(response.confirmedAddress);
      }

      $form.submit();
    }
  };

  testShouldVerifyAddress() {
    const { avsProvider, isRecaptchaEnabled } = this;

    if (!this.testPasswordsMatch()) {
      return false;
    }

    if (isRecaptchaEnabled) {
      if (!window.grecaptcha.getResponse()) {
        return false;
      }
    }

    return avsProvider.testCanVerifyAddress();
  }

  testPasswordsMatch() {
    const { $form } = this;
    const $inputPassword = dom.findFrom($form, '#PatronRegister_Password');
    const $inputPasswordConfirm = dom.findFrom($form, '#PatronRegister_ConfirmPassword');

    return $inputPassword.value === $inputPasswordConfirm.value;
  }
}


export default AccountCreateUpdateFormHandler;



// WEBPACK FOOTER //
// ./V7/account/AccountCreateUpdateFormHandler.js